import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 18 18.389',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g transform="translate(-4 -2)">
      <path
        d="M23.092 9.9H19.2l1.733-1.752-.9-1.008-3.312 3.337v.266L20 14.018l.9-.855-1.7-1.848h3.765a1.735 1.735 0 0 1 1.527.855 2.693 2.693 0 0 1 .312 1.34h1.478a4.771 4.771 0 0 0-.52-2.068 2.691 2.691 0 0 0-2.67-1.542z"
        fill={fill}
        transform="translate(-4.282 -1.421)"
      />
      <g transform="translate(4 2)">
        <g>
          <path
            d="M13.814 20.366c-1.541 0-4.427-.793-6.992-5.877l-.7-1.549C3.4 6.046 6.388 3.583 7.154 3.088a1.94 1.94 0 0 1 .42-.266 7.463 7.463 0 0 1 1.839-.8l.154-.044.158.022c.344.056 1.037.413 1.824 2.175.77 1.723.592 2.482.31 2.817l-.132.155-2.189.718c-.329.212-.617 2.231-.04 3.566l.68 1.51c.626 1.389 2.374 2.464 2.747 2.322l2.223-1.279.389.373A6.656 6.656 0 0 1 17 16.432a4.356 4.356 0 0 1 .481 2.279l-.022.364-.307.2a6.59 6.59 0 0 1-1.852.825 2.71 2.71 0 0 1-.481.143 3.717 3.717 0 0 1-1.005.123zM9.489 3.505a5.936 5.936 0 0 0-1.2.567l-.089.049a.484.484 0 0 0-.135.086l-.1.075c-.305.188-2.915 2.011-.513 8.1l.672 1.489c2.912 5.766 6.018 5.07 6.362 4.972a1.584 1.584 0 0 0 .3-.09l.1-.035a5.148 5.148 0 0 0 1.16-.459 2.962 2.962 0 0 0-.335-1.193 5.444 5.444 0 0 0-.806-1.279l-1.327.762a2.9 2.9 0 0 1-2.724-.659 6.4 6.4 0 0 1-1.988-2.353l-.686-1.522a6.449 6.449 0 0 1-.114-4.387 1.877 1.877 0 0 1 .967-1.108l1.61-.531a5.048 5.048 0 0 0-.409-1.225 4.7 4.7 0 0 0-.745-1.259zm-.134-.122z"
            fill={fill}
            transform="translate(-5 -1.977)"
          />
        </g>
      </g>
    </g>
  </svg>
);
export default SVG;
